var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{class:"elevation-0"+ " " + _vm.className,attrs:{"color":_vm.color,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('change', !_vm.value)}}},[_c('span',{class:_vm.className},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }